/**
 * CPV code hierarchy for the profile picker.
 * Each division (2-digit) may have groups (3-digit) nested inside.
 * Stored codes in cpv_interests can be 2- or 3-digit.
 * The backend uses prefix matching: selecting "72" matches all "722..." codes.
 */

export const CPV_TREE = [
  { code: '45', label: 'Construction works', groups: [
    { code: '451', label: 'Site preparation works' },
    { code: '452', label: 'Building construction works' },
    { code: '453', label: 'Building installation works' },
    { code: '454', label: 'Building completion works' },
    { code: '455', label: 'Other construction works' },
  ]},
  { code: '48', label: 'Software packages', groups: [
    { code: '480', label: 'Software packages (general)' },
    { code: '481', label: 'Information management software' },
    { code: '482', label: 'Operating system software' },
    { code: '483', label: 'Development tools software' },
    { code: '484', label: 'Application software' },
    { code: '485', label: 'Internet software' },
    { code: '486', label: 'Educational software' },
  ]},
  { code: '50', label: 'Repair & maintenance services', groups: [] },
  { code: '60', label: 'Transport services', groups: [] },
  { code: '63', label: 'Logistics & cargo', groups: [] },
  { code: '64', label: 'Postal & telecom services', groups: [] },
  { code: '65', label: 'Public utilities', groups: [] },
  { code: '66', label: 'Financial & insurance services', groups: [] },
  { code: '70', label: 'Real estate services', groups: [] },
  { code: '71', label: 'Architecture & engineering services', groups: [
    { code: '711', label: 'Architectural services' },
    { code: '712', label: 'Engineering design services' },
    { code: '713', label: 'Engineering advisory services' },
    { code: '714', label: 'Technical testing and analysis' },
  ]},
  { code: '72', label: 'IT services', groups: [
    { code: '720', label: 'IT services (general)' },
    { code: '721', label: 'Internet services' },
    { code: '722', label: 'Software programming and consultancy' },
    { code: '723', label: 'Data processing and related services' },
    { code: '724', label: 'Database services' },
    { code: '725', label: 'Office machinery maintenance' },
    { code: '726', label: 'IT-related services' },
    { code: '727', label: 'IT support and consultancy' },
  ]},
  { code: '73', label: 'Research & development services', groups: [] },
  { code: '75', label: 'Public administration & defence', groups: [] },
  { code: '77', label: 'Agricultural & forestry services', groups: [] },
  { code: '79', label: 'Business services', groups: [
    { code: '791', label: 'Accounting, auditing and fiscal services' },
    { code: '792', label: 'Human resources services' },
    { code: '793', label: 'Translation and interpretation services' },
    { code: '794', label: 'Advertising and marketing services' },
    { code: '795', label: 'Recruitment services' },
    { code: '796', label: 'Investigation and security services' },
    { code: '797', label: 'Other business services' },
  ]},
  { code: '80', label: 'Education & training services', groups: [
    { code: '801', label: 'Primary and secondary education' },
    { code: '802', label: 'Technical and vocational education' },
    { code: '803', label: 'Higher education' },
    { code: '804', label: 'Adult and other education' },
  ]},
  { code: '85', label: 'Health & social work services', groups: [
    { code: '851', label: 'Health services' },
    { code: '852', label: 'Veterinary services' },
    { code: '853', label: 'Social work services' },
  ]},
  { code: '90', label: 'Environmental & sewage services', groups: [
    { code: '900', label: 'Sewage and refuse services' },
    { code: '901', label: 'Refuse collection services' },
    { code: '902', label: 'Groundwater and water treatment' },
    { code: '903', label: 'Environmental consulting' },
  ]},
  { code: '92', label: 'Cultural & recreational services', groups: [] },
  { code: '98', label: 'Other community services', groups: [] },
  { code: '33', label: 'Medical equipment', groups: [
    { code: '331', label: 'Surgical and medical instruments' },
    { code: '332', label: 'Medical instruments and devices' },
    { code: '333', label: 'Electro-diagnostic apparatus' },
    { code: '334', label: 'Pharmaceutical products' },
  ]},
  { code: '35', label: 'Security & defence equipment', groups: [
    { code: '350', label: 'Security equipment (general)' },
    { code: '351', label: 'Firefighting and safety equipment' },
    { code: '352', label: 'Police equipment' },
    { code: '353', label: 'Military and defence equipment' },
  ]},
  { code: '24', label: 'Chemical products', groups: [] },
  { code: '30', label: 'Office & computing machinery', groups: [] },
  { code: '31', label: 'Electrical equipment', groups: [] },
  { code: '32', label: 'Communications equipment', groups: [] },
  { code: '34', label: 'Transport equipment', groups: [] },
  { code: '38', label: 'Laboratory equipment', groups: [] },
  { code: '39', label: 'Furniture & carpets', groups: [] },
  { code: '44', label: 'Construction materials', groups: [] },
  { code: '15', label: 'Food & beverages', groups: [] },
  { code: '03', label: 'Agriculture & forestry', groups: [] },
  { code: '09', label: 'Petroleum products', groups: [] },
];

/** Flat map from code → label for quick lookups */
export const CPV_LABELS = {};
for (const div of CPV_TREE) {
  CPV_LABELS[div.code] = div.label;
  for (const grp of div.groups) {
    CPV_LABELS[grp.code] = grp.label;
  }
}
